import styled, { css } from "styled-components"
import { transparentize } from "polished"

const getPaddingFromSize = (size, theme) => {
  switch (size) {
    case "small":
      return "0.5rem 1rem 0.5rem 2.25rem"
    case "medium":
      return "1rem 2rem 1rem 3.25rem"
    case "large":
      return "1.25rem 2.5rem 1.25rem 3.75rem"
    default:
      return "0.75rem 1.5rem 0.75rem 2.75rem"
  }
}

export const StyledField = styled.input`
  border-radius: 0.5rem;
  font-size: 1rem;
  line-height: 1.4;
  padding: ${({ size, theme }) => getPaddingFromSize(size, theme)};
  border: 1px solid #d8d8d8;
  color: ${({ theme }) => theme.colors.secondaryAlternative || theme.colors.secondary};
  width: unset;
  font-weight: bold;
  background-color: #f4f4f4;
  background-image: url("data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 6.5C13 7.9375 12.5312 9.28125 11.75 10.3438L15.6875 14.3125C16.0938 14.6875 16.0938 15.3438 15.6875 15.7188C15.3125 16.125 14.6562 16.125 14.2812 15.7188L10.3125 11.75C9.25 12.5625 7.90625 13 6.5 13C2.90625 13 0 10.0938 0 6.5C0 2.9375 2.90625 0 6.5 0C10.0625 0 13 2.9375 13 6.5ZM6.5 11C8.09375 11 9.5625 10.1562 10.375 8.75C11.1875 7.375 11.1875 5.65625 10.375 4.25C9.5625 2.875 8.09375 2 6.5 2C4.875 2 3.40625 2.875 2.59375 4.25C1.78125 5.65625 1.78125 7.375 2.59375 8.75C3.40625 10.1562 4.875 11 6.5 11Z' fill='%23AAAAAA'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: 17px center;

  &::placeholder {
    color: ${({ theme }) => transparentize(0.6, theme.colors.secondaryAlternative || theme.colors.secondary)};
  }

  &:focus,
  &:active {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
  }

  ${({ disabled }) =>
    !!disabled &&
    css`
      cursor: not-allowed;
    `}
`
